<template>
  <div class="registration-order-list">

    <van-loading v-if="loading" class="loading" type="spinner" vertical>加载中...</van-loading>
    <van-empty v-else-if="orders.length === 0" description="暂无订单" />

    <template v-else>
      <div class="list">
      <div v-for="(item, index) in orders" :key="item.id || item.playerId || item.orderId || index" class="card">
        <!-- 第一行：赛事名称 | 订单状态 -->
        <div class="row1">
          <span class="match-name">{{ item.chineseName || item.matchName || item.matchChineseName || '-' }}</span>
          <span class="status" :class="statusClass(item)">{{ getOrderStatusText(item) }}</span>
        </div>
        <!-- 第二行：球员 logo | 球员名称、球队名称 | 价格 -->
        <div class="row2">
          <div class="logo">
            <img v-if="item.avatar" :src="imageView(item.avatar)" alt="" />
            <img v-else src="@/assets/player-default.png" alt="" />
          </div>
          <div class="info">
            <div class="player-name">{{ item.trueName || item.playerName || '-' }}</div>
            <div class="team-name">{{ item.name || item.teamName || '-' }}</div>
          </div>
          <div class="price-wrap">
            <span class="price">￥{{ formatAmount(item) }}</span>
          </div>
        </div>
        <!-- 每一项右下角：未完成注册显示去注册，待付款显示去付款 -->
        <div v-if="getOrderStatusText(item) !== '已支付'" class="card-actions">
          <van-button
            class="item-btn"
            type="info"
            size="small"
            @click="onItemAction(item)"
          >
            {{ getOrderStatusText(item) === '未完成注册' ? '去注册' : '去付款' }}
          </van-button>
        </div>
      </div>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { Loading, Empty, Button, Toast } from 'vant'
import { getMatchTeamListByUser } from '@/api/match'
import { QNImageUtil } from '@/utils'
import wx from 'weixin-js-sdk'
Vue.use(Loading).use(Empty).use(Button).use(Toast)

export default {
  name: 'RegistrationOrderList',
  data() {
    return {
      unionMatchId: '',
      teamId: '',
      loading: false,
      orders: []
    }
  },
  computed: {
    imageView() {
      return (hash) => (hash ? QNImageUtil.imageView(hash) : '')
    }
  },
  mounted() {
    this.unionMatchId = this.$route.query.unionMatchId || ''
    this.teamId = this.$route.query.teamId || ''
    this.fetchOrders()
    this.bindReturnRefresh()
  },
  beforeDestroy() {
    this.unbindReturnRefresh()
  },
  methods: {
    /** 从小程序回退到当前 H5 时刷新列表：点击去注册时标记，事件 + 轮询兜底（小程序 webview 可能不触发 visibility/focus） */
    bindReturnRefresh() {
      const tryRefresh = () => {
        if (!this._expectRefreshOnReturn) return
        if (this._returnRefreshTimer) return
        this._returnRefreshTimer = setTimeout(() => {
          this._returnRefreshTimer = null
          this._expectRefreshOnReturn = false
          this.stopReturnRefreshPolling()
          this.fetchOrders()
        }, 200)
      }
      this._onVisibility = () => {
        if (document.visibilityState === 'visible') tryRefresh()
      }
      this._onPageshow = (e) => {
        if (e.persisted) tryRefresh()
      }
      this._onFocus = () => tryRefresh()
      document.addEventListener('visibilitychange', this._onVisibility)
      window.addEventListener('pageshow', this._onPageshow)
      window.addEventListener('focus', this._onFocus)
    },
    /** 开始轮询：从小程序返回后 webview 可见时刷新（部分环境不触发 visibilitychange） */
    startReturnRefreshPolling() {
      this.stopReturnRefreshPolling()
      this._returnRefreshPolling = setInterval(() => {
        if (!this._expectRefreshOnReturn) return
        if (document.visibilityState === 'visible') {
          this._expectRefreshOnReturn = false
          this.stopReturnRefreshPolling()
          this.fetchOrders()
        }
      }, 500)
    },
    stopReturnRefreshPolling() {
      if (this._returnRefreshPolling) {
        clearInterval(this._returnRefreshPolling)
        this._returnRefreshPolling = null
      }
    },
    unbindReturnRefresh() {
      if (this._returnRefreshTimer) {
        clearTimeout(this._returnRefreshTimer)
        this._returnRefreshTimer = null
      }
      this.stopReturnRefreshPolling()
      document.removeEventListener('visibilitychange', this._onVisibility)
      window.removeEventListener('pageshow', this._onPageshow)
      window.removeEventListener('focus', this._onFocus)
      this._onVisibility = null
      this._onPageshow = null
      this._onFocus = null
    },
    /** 注册费用用 registerPrice，赛事报名费用用 feeAmount */
    formatAmount(item) {
      if (!item) return '0.00'
      // const step = (item.registerStep != null ? item.registerStep : item.currentStep) || ''
      // const stepStr = String(step)
      const isRegisterFee = (item.registerStatus === 'ORDER_CREATED' || item.registerStatus === 'SUBMITTED')
      const raw = isRegisterFee ? item.registerPrice : item.feeAmount
      const n = Number(raw) / 100
      if (Number.isFinite(n)) return n.toFixed(2)
      const fallback =
        item.totalFee ??
        item.fee ??
        item.amount ??
        item.payAmount ??
        item.price ??
        item.signupFee ??
        item.orderAmount
      const m = Number(fallback)
      return Number.isFinite(m) ? m.toFixed(2) : '0.00'
    },
    /**
     * 订单状态：先判断是否完成注册，再判断是否支付赛事报名费用
     * 未完成注册 → 待付款 → 已支付
     */
    getOrderStatusText(item) {
      if (!item) return '-'
      if (item.registerStatus === 'ORDER_CREATED' || item.registerStatus === 'SUBMITTED') {
        return '未完成注册'
      }
      // 2. 已支付：赛事报名费 orderStatus 1 或 2
      // const orderStatus = item.orderStatus != null ? Number(item.orderStatus) : null
      if (item.isOpenCharge === 1 && item.feeMethod === 1 && item.orderStatus !== 1 && item.orderStatus !== 2) {
        return '待付款'
      }
      return '已支付'
    },
    statusClass(item) {
      const text = this.getOrderStatusText(item)
      if (text === '已支付') return 'success'
      return 'danger' // 未完成注册、待付款
    },
    async fetchOrders() {
      if (!this.unionMatchId) {
        this.orders = []
        return
      }
      this.loading = true
      try {
        const res = await getMatchTeamListByUser({
          unionMatchId: this.unionMatchId,
          role: 0,
          orderIndex: 0
        })
        const data = (res && res.data) || {}
        const list = data.list || []
        // 筛选：teamId 匹配、feeMethod=1、orderStatus!=1（含 null）
        this.orders = list.filter(item => {
          const teamMatch = !this.teamId || String(item.teamId) === String(this.teamId)
          const feeOk = Number(item.feeMethod) === 1
          // const orderNotPaid = item.orderStatus == null || Number(item.orderStatus) !== 1
          return teamMatch && feeOk // && orderNotPaid
        })
      } catch (e) {
        Toast.fail(e?.message || '获取订单失败')
        this.orders = []
      } finally {
        this.loading = false
      }
    },
    /** 每一项右下角按钮：去注册 / 去付款 */
    onItemAction(item) {
      if (item.registerStatus === 'ORDER_CREATED' || item.registerStatus === 'SUBMITTED') {  // 注册
        this._expectRefreshOnReturn = true
        this.startReturnRefreshPolling()  // 轮询兜底：部分小程序 webview 回退不触发 visibility/focus
        if (item.registerOrderId) {
           wx.miniProgram.navigateTo({ url: `/pages/order/detail/index?id=${item.registerOrderId}` })
        } else {
          wx.miniProgram.navigateTo({ url: `/pages/season_registration/order_confirm/index?id=${item.registerChannelId}&regPlayerId=${item.regPlayerId}&type=Player.Registration` })
        }
        return
      }
      if (item.isOpenCharge === 1 && item.feeMethod === 1 && item.orderStatus !== 1 && item.orderStatus !== 2) {
        // 去付款：本 H5 内跳 payment2，不设期待刷新（payment2 支付成功会跳成功页或 redirectUrl）
        this.$router.push(`/entry-page/payment2?matchId=${item.matchId}&teamId=${item.teamId}&playerId=${item.playerId}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.registration-order-list {
  min-height: 100vh;
  background: var(--bg1);
  padding: 16px;
  box-sizing: border-box;
}
.title-info {
  padding: 0 0 12px 0;
  .h1 {
    font-size: 18px;
    color: #1d2129;
    font-weight: 500;
  }
}
.loading {
  padding: 40px 0;
}
.list {
  .card {
    background: var(--bg2);
    border-radius: 8px;
    padding: 12px 16px;
    margin-top: 12px;
    .row1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      .match-name {
        flex: 1;
        min-width: 0;
        font-size: 14px;
        color: #1d2129;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-right: 8px;
      }
      .status {
        flex-shrink: 0;
        font-size: 13px;
        font-weight: 600;
        &.danger {
          color: #bc2d2f;
        }
        &.success {
          color: #0fac7f;
        }
      }
    }
    .row2 {
      display: flex;
      align-items: center;
    }
    .logo {
      width: 56px;
      height: 56px;
      border-radius: 4px;
      overflow: hidden;
      flex-shrink: 0;
      background: #e8e8e8;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .info {
      flex: 1;
      min-width: 0;
      margin-left: 12px;
      .player-name {
        font-size: 15px;
        font-weight: 600;
        color: #1d2129;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .team-name {
        font-size: 13px;
        color: #606266;
        margin-top: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .price-wrap {
      flex-shrink: 0;
      .price {
        font-size: 14px;
        font-weight: 500;
        color: #1d2129;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      margin-top: 12px;
      .pay-btn {
        width: 92px;
        height: 34px;
        border-radius: 4px;
      }
    }
    .card-actions {
      display: flex;
      justify-content: flex-end;
      margin-top: 12px;
      .item-btn {
        min-width: 80px;
        height: 34px;
        border-radius: 4px;
        background: #1D2088;
        border: none;
      }
    }
  }
}
</style>
